app.service('main',function(loading, dispatcher, html, callback){
	var isInit=false;
	function init(){
		if(!isInit){
			callback.run('beforeInit');
			dispatcher.pageRun();
			UA.init();
			isInit=true;
			html.add('page-init');
			callback.run('afterInit');
		}
	}
	$().ready(function() {
		if($('#error-404').length){
			load404();
			return;
		}
		if($('#error-403').length){
			load403();
			return;
		}
		init();
	});
	function load404(){
		$.ajax({
			url:'/404.bhtml',
			success:function(html){
				$('body').append($('<div>'+html+'</div>').find('#error404')[0].outerHTML);
				setTimeout(function(){
					init();
				},100);
			}
		});
	}
	function load403(){
		$.ajax({
			url:'/403.bhtml',
			success:function(html){
				$('body').html($('<div>'+html+'</div>').find('#error403')[0].outerHTML);
				setTimeout(function(){
					init();
				},100);
			}
		});
	}
});
UA.unlockAccessories();
